import "./LittleSpinner.css"


export default function Spinner({padding}) {


    return <span className="spinner" style={{padding}}>
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>      
    </span>

}